module.exports = __webpack_public_path__ + "img/pliceicon.d0289dc0.png";